.container {
    align-items: baseline;
    border: none;
    display: flex;
    max-width: 100%;
    margin: 1rem 0;
}

.containerExpanded {
    flex-direction: column;
}

.content {
    color: #999;
    display: block;
    font-size: 14px;
    white-space: nowrap;
}

.contentOverflow {
    overflow: hidden;
    text-overflow: ellipsis;
}

.contentExpanded {
    white-space: initial;
}

.showButton {
    all: unset;
    color: #333;
    font-size: 13px;
    padding: 2px 4px;
    white-space: nowrap;
    cursor: pointer;
}

.showButton:hover {
    text-decoration: underline;
}

.showButtonExpanded {
    margin-top: 0.5rem;
}

.showButtonHidden {
    display: none;
}
